// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3QAXx","noInteraction":"EventWrapper_noInteraction__ThLjq"};